import { Package, Pencil, Trash2, Star, LayoutTemplate } from "lucide-react";

function Badge({ label, variant = "default" }) {
  const cls =
    variant === "shopify"
      ? "bg-green-500/15 text-green-400 border-green-500/20"
      : variant === "local"
        ? "bg-[#CBA052]/15 text-[#CBA052] border-[#CBA052]/20"
        : "bg-white/5 text-white/40 border-white/10";
  return (
    <span className={`text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded border ${cls}`}>
      {label}
    </span>
  );
}

/**
 * Single row in the admin product list. Accepts edit/delete/select callbacks
 * and highlights the active presentation target.
 */
export default function ProductListRow({
  product,
  selected,
  presentationActive,
  onToggleSelect,
  onEdit,
  onDelete,
  onTogglePresentation,
}) {
  const p = product;
  return (
    <div
      className="flex items-center gap-3 border border-white/[0.06] bg-white/[0.02] rounded p-3 group hover:border-white/10 transition-colors"
      data-testid={`product-row-${p.id}`}
    >
      <input
        type="checkbox"
        checked={selected}
        onChange={onToggleSelect}
        className="w-3.5 h-3.5 rounded border-white/20 bg-transparent accent-[#CBA052] shrink-0 cursor-pointer"
        data-testid={`product-checkbox-${p.id}`}
      />
      <div className="w-12 h-12 rounded overflow-hidden shrink-0 bg-white/[0.03]">
        {p.image_url ? (
          <img src={p.image_url} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Package size={16} className="text-white/15" />
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-white truncate">{p.title}</span>
          {p.featured && <Star size={10} className="text-[#CBA052] shrink-0" />}
          <Badge label={p.source || "local"} variant={p.source === "shopify" ? "shopify" : "local"} />
          <Badge label={p.status || "draft"} />
        </div>
        <p className="text-[10px] text-white/30 truncate">
          {p.product_type || p.category || "—"} &middot; {p.handle}
        </p>
      </div>
      <span className="text-xs font-bold text-white shrink-0">{p.price ? `£${p.price}` : "—"}</span>
      <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
        {p.source !== "shopify" && (
          <>
            <button onClick={onEdit} className="p-1.5 bg-white/5 rounded hover:bg-white/10" title="Edit">
              <Pencil size={11} className="text-white/40" />
            </button>
            <button onClick={onDelete} className="p-1.5 bg-white/5 rounded hover:bg-red-500/20" title="Delete">
              <Trash2 size={11} className="text-white/40" />
            </button>
          </>
        )}
        <button
          onClick={onTogglePresentation}
          className={`p-1.5 rounded transition-colors ${presentationActive ? "bg-[#CBA052]/20 text-[#CBA052]" : "bg-white/5 hover:bg-[#CBA052]/10 hover:text-[#CBA052] text-white/40"}`}
          title="Manage Presentation"
          data-testid={`product-presentation-btn-${p.id}`}
        >
          <LayoutTemplate size={11} />
        </button>
      </div>
    </div>
  );
}
